/** @deprecated Use `useCollapsibleControls()` instead. */
export const COLLAPSIBLE_CONTROLS_DOM_ATTRIBUTE = '@ci/accordion/collapsibleControls';
